// extracted by mini-css-extract-plugin
export default {"container":"_34G9","round":"_2yPW","justified":"_1Vso","elevation1":"_2nFC"};